import React from 'react';
import Dropzone from 'react-dropzone';
import IconUpload from 'material-ui/svg-icons/file/file-upload';
import LinearProgress from 'material-ui/LinearProgress';

export default ({ uploadProgress, uploading, style, ...props }) => (
  <Dropzone
    {...props}
    style={{ border: '3px dotted lightblue', width: 200, ...style }}
    rejectStyle={{ border: '3px dotted tomato', width: 200 }}
    acceptStyle={{ border: '3px dotted mediumspringgreen', width: 200 }}
    activeStyle={{ border: '3px dotted lightblue', width: 200 }}
  >
    <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column', padding: 5}}>
      <IconUpload style={{ width: 64, height: 64 }} />
      <h3 style={{ padding: 10, textAlign: 'center' }}>
        { uploading ? 'Uploading...' : 'Choose a file or drop it here'}
      </h3>
      <LinearProgress
        min={0}
        max={100}
        value={uploadProgress}
        mode="determinate"
      />
    </div>
  </Dropzone>
);


// WEBPACK FOOTER //
// ./src/components/FileUpload.js